import { useState, useEffect } from 'react';
import type { INetworksResponse } from 'src/interfaces/network.model';

export function useAppState(networksData: INetworksResponse) {
  const [currentNetwork, setCurrentNetwork] = useState<string | null>(null);
  const [currentToken, setCurrentToken] = useState<string | null>(null);
  const [currentTokenPrice, setCurrentTokenPrice] = useState(null);
  const [language, setLanguage] = useState<string>('EN');

  useEffect(() => {
    if (window.WP_REACT_LOCALIZATION != null) {
      setLanguage(window.WP_REACT_LOCALIZATION.locale);
    }
  }, []);

  useEffect(() => {
    if (networksData != null && networksData?.networks.length > 0) {
      const storedNetwork = localStorage.getItem('currentNetwork');
      if (storedNetwork != null && networksData.networks.some((network) => network.nameId === storedNetwork)) {
        setCurrentNetwork(storedNetwork);
      } else {
        setCurrentNetwork(networksData.networks[0].nameId);
        localStorage.setItem('currentNetwork', networksData.networks[0].nameId);
      }
    }
  }, [networksData]);

  return {
    currentNetwork,
    setCurrentNetwork,
    currentToken,
    setCurrentToken,
    currentTokenPrice,
    setCurrentTokenPrice,
    language,
  };
}
